<div class="loaderWrapper">
  <div
    class="loader"
    [ngClass]="{ 'size-large': size === 'large', 'size-medium': size === 'medium', 'size-small': size === 'small' }"
  ></div>
</div>
